module.exports = __webpack_public_path__ + "static/media/icon-cards-gray.c1cee5fd.svg";